import React from "react";
import { Link } from "react-router-dom";

/**
 * BREADCRUMB — Componente de Título e Navegação
 *
 * Props:
 *   @param {string} title          — Título da página (obrigatório)
 *   @param {array}  breadcrumbItems — Array de { title, link } (opcional)
 *
 * Uso:
 *   <Breadcrumb title="Clientes" />
 *   <Breadcrumb title="Detalhes" breadcrumbItems={[{ title: "Clientes", link: "/members" }, { title: "João" }]} />
 */
const Breadcrumb = ({ title, breadcrumbItems }) => {
    return (
        <div className="neo-page-header__left">
            <h4 className="neo-page-header__title">{title}</h4>
            {breadcrumbItems && breadcrumbItems.length > 0 && (
                <ol className="breadcrumb neo-page-header__breadcrumb">
                    {breadcrumbItems.map((item, key) => (
                        <li
                            key={key}
                            className={`breadcrumb-item ${
                                key + 1 === breadcrumbItems.length ? "active" : ""
                            }`}
                        >
                            {key + 1 === breadcrumbItems.length ? (
                                item.title
                            ) : (
                                <Link to={item.link || "#"}>{item.title}</Link>
                            )}
                        </li>
                    ))}
                </ol>
            )}
        </div>
    );
};

export default Breadcrumb;
